<script setup>
import { useStatisticsStore } from "@/stores";
import { computed, onMounted } from "vue";
import Area from "@/components/charts/Area";

const statisticsStore = useStatisticsStore();

const stats = computed(() => statisticsStore.dashboard);

const colors = ["#5096B4", "#E91E63"];

onMounted(async () => {
  await statisticsStore.fetchDashboardStats();
});
</script>

<template>
  <v-container class="d-flex flex-column gap-20">
    <v-row>
      <v-col cols="12" sm="6">
        <Box
          color="primary"
          :text="stats.beneficiary"
          title="Beneficiaries"
          icon="mdi-briefcase"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <Box
          color="academy"
          :text="stats.academy"
          title="Courses"
          icon="mdi-briefcase"
        />
      </v-col>
      <v-col cols="6" sm="3">
        <Box
          color="employability"
          :text="stats.employability"
          title="Employabilities"
          icon="mdi-briefcase"
        />
      </v-col>
      <v-col cols="6" sm="3">
        <Box
          color="employability"
          :text="stats.livelihood"
          title="Livelihoods"
          icon="mdi-briefcase"
        />
      </v-col>
      <v-col cols="6" sm="3">
        <Box
          color="company"
          :text="stats.company"
          title="Companies"
          icon="mdi-domain"
        />
      </v-col>
      <v-col cols="6" sm="3">
        <Box
          color="company"
          :text="stats.jobPosition"
          title="Positions"
          icon="mdi-briefcase"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="Object.keys(stats).length > 0" cols="12">
        <Area
          :series="stats.graph.series"
          :height="550"
          :colors="colors"
          title="Number of last year's new registrations per week"
          :categories="stats.graph.labels"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
